module.exports = __webpack_public_path__ + "b0c926037731bf8ece5bafba988f8136.svg";